import { useMutation } from 'react-query';
import { getAllEventsCountByDeviceIdAsync } from '../../index';

export const useGetAllEventsCountByDeviceIdAsync = () =>
  useMutation(getAllEventsCountByDeviceIdAsync);
